//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,getDate} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import bottom from '@/assets/img/bottom.png'

export default {
  name: "sendOrderAdd",
  components: {
    footerNav
  },
  data() {
    return {
      list:[
      ],
      provider:'',
      channel:'',
      radio:'',
      ems:'',
      bottom,
      address:'',
      showPicker:false,
      showPicker1:false,
      showPicker2:false,
      showPicker3:false,
      showPicker4:false,
      showPicker5:false,
      date:'',
      currentDate:'',
      color:'',
      tel:'',
      way:'',
      purchaseId:'',
      emsId:'',
      save:'',
      columns: ['方式1', '方式2'],
      columns1: ['供应商1', '供应商2'],
      columns2: ['渠道1', '渠道2'],
      columns3: ['快递公司1', '快递公司2'],
      value:'',
    }
  },
  activated() {
    if(this.$route.params&&this.$route.params.arr){
      this.list=this.list.concat(this.$route.params.arr)
    }else{
      this.list = [];
      this.provider = '';
      this.channel = '';
      this.ems = '';
      this.showPicker = false;
      this.showPicker1 = false;
      this.showPicker2 = false;
      this.showPicker3 = false;
      this.showPicker4 = false;
      this.showPicker5 = false;
      this.date = '';
      this.currentDate = '';
      this.color = '';
      this.way = '';
      this.purchaseId = '';
      this.value = '';
      this.address = '';
      this.tel = '';
      this.emsId = '';
      this.save = '';
    }
  },
  created() {
    // if(this.$route.params&&this.$route.params.arr){
    //   this.list=this.list.concat(this.$route.params.arr)
    // }
  },
  mounted() {
  },
  methods: {
    onConfirm(value) {
      this.way = value;
      this.showPicker = false;
    },
    onConfirm1(value) {
      this.provider = value;
      this.showPicker1 = false;
    },
    onConfirm2(value) {
      this.channel = value;
      this.showPicker2 = false;
    },
    onConfirm3(value) {
      this.ems = value;
      this.showPicker3 = false;
    },
    onConfirm5(value) {
      this.date = getDate(value.getTime());
      this.showPicker5 = false;
    },
    toEdit(){
      this.$router.push({name:'productCertificateEdit'})
    },
    next(){
      this.$router.push({name:'sendOrder'})
    },
    chooseConfirm(){
      this.purchaseId = 78954727524120576
      this.showPicker4=false
    },
    onSearch(){

    },
    toAddRow(){
      this.$router.push({name:'sendOrderRowAdd'})
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/sendOrder/add.vue